// BottomNav.jsx
import { NavLink } from "react-router-dom";
import "./Navbar1.css";
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';


const BottomNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  // ===== اتصال به تم ناوبر بالا (navbar2) =====
  const [isDark, setIsDark] = useState(() => {
    try {
      return localStorage.getItem('navbar2-drawer-dark') === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === 'navbar2-drawer-dark') {
        setIsDark(e.newValue === '1');
      }
    };
    window.addEventListener('storage', handleStorage);

    // polling برای همان تب
    const interval = setInterval(() => {
      try {
        const current = localStorage.getItem('navbar2-drawer-dark') === '1';
        setIsDark((prev) => (prev !== current ? current : prev));
      } catch {}
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorage);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
  let timeout;

  const handleTouchStart = () => {
    clearTimeout(timeout);
    setIsScrolled(true);
  };

  const handleTouchEnd = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => setIsScrolled(false), 1000);
  };

  window.addEventListener('touchstart', handleTouchStart, { passive: true });
  window.addEventListener('touchend', handleTouchEnd, { passive: true });
  window.addEventListener('touchcancel', handleTouchEnd, { passive: true });

  return () => {
    window.removeEventListener('touchstart', handleTouchStart);
    window.removeEventListener('touchend', handleTouchEnd);
    window.removeEventListener('touchcancel', handleTouchEnd);
    clearTimeout(timeout);
  };
}, []);



  const { user } = useAuth();
  const userRole = user?.role || 'student';
  const examsLink = (userRole === 'teacher' || userRole === 'admin' || userRole === 'superadmin') 
  ? '/exams/teacher' 
  : '/exams/student';

  const privateClassLink = 
  userRole === 'student' ? '/private-class/student' :
  userRole === 'teacher' ? '/private-class/teacher' :
  userRole === 'admin'  ? '/private-class/admin' :
  '/home';

  const homeClassLink = 
  userRole === 'student' ? '/StudentHome' :
  userRole === 'teacher' ? '/TeacherHome' :
  userRole === 'admin'  ? '/AdminHome' :
  userRole === 'parent'  ? '/ParentHome' :
  '/login';



  // ===== لینک پنل (فقط برای معلم و مدیر) =====
// ===== لینک درس‌ها بر اساس نقش =====
// 🆕 معلم هم مثل دانش‌آموز به صفحه‌ی کتاب‌ها می‌رود
//    (بنر «ساخت کلاس» در صفحه‌ی انتخاب استاد نمایش داده می‌شود)
const booksLink =
  userRole === 'teacher' ? '/books' :
  userRole === 'admin'   ? '/admin/books' :
  '/books'; // دانش‌آموز، والدین و معلم → صفحه‌ی کتاب‌ها




  // ===== ترتیب از راست به چپ: خانه، آزمون‌ها، بازی‌ها، درس‌ها =====
  const navItems = [
    { id: 3, icon: 'fa-book', label: 'درس‌ها', link: booksLink },
    { id: 2, icon: 'fa-gamepad', label: 'کلاس خصوصی', link: privateClassLink },
    { id: 1, icon: 'fa-tasks', label: 'آزمون‌ها', link: examsLink },
    { id: 0, icon: 'fa-home', label: 'خانه', link: homeClassLink },
  ];

  return (
    <div className="bottom-nav-wrapper" data-role={userRole} data-theme={isDark ? 'dark' : 'light'}>
      {/* ===== نوار اصلی ===== */}
      <div className="bottom-nav">
        {/* سمت راست: خانه */}
        <NavLink
          to={navItems[0].link}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="glow-ring"></span>}
              <i className={`fas ${navItems[0].icon}`}></i>
              <span className="label">{navItems[0].label}</span>
            </>
          )}
        </NavLink>

        {/* آزمون‌ها */}
        <NavLink
          to={navItems[1].link}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="glow-ring"></span>}
              <i className={`fas ${navItems[1].icon}`}></i>
              <span className="label">{navItems[1].label}</span>
            </>
          )}
        </NavLink>

        {/* 🆕 مطالعه آزاد — فقط برای مدیر */}
        {userRole === 'admin' && (
          <NavLink
            to="/admin/free-study"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="glow-ring"></span>}
                <i className="fas fa-video"></i>
                <span className="label">مطالعه آزاد</span>
              </>
            )}
          </NavLink>
        )}

        {/* 🆕 آپلود فایل‌های PDF (کتاب، کار، جزوه) — فقط برای مدیر */}
        {userRole === 'admin' && (
          <NavLink
            to="/admin/upload-pdf"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="glow-ring"></span>}
                <i className="fas fa-file-upload"></i>
                <span className="label">آپلود فایل</span>
              </>
            )}
          </NavLink>
        )}

        {/* AI DROP (مرکز) */}
        <NavLink to="/ai" className="ai-drop-container">
          <div className="ai-drop">
            <span className="water-ring"></span>
            <span className="water-ring"></span>
            <span className="water-ring"></span>
            <i className="fas fa-brain ai-icon"></i>
          </div>
          <span className="ai-drop-label">AI</span>
        </NavLink>

        {/* کلاس خصوصی*/}
        <NavLink
          to={navItems[2].link}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="glow-ring"></span>}
              <i className={`fas ${navItems[2].icon}`}></i>
              <span className="label">{navItems[2].label}</span>
            </>
          )}
        </NavLink>

        {/* سمت چپ: درس‌ها */}
        <NavLink
          to={navItems[3].link}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="glow-ring"></span>}
              <i className={`fas ${navItems[3].icon}`}></i>
              <span className="label">{navItems[3].label}</span>
            </>
          )}
        </NavLink>
      </div>

      {/* ===== دکمه گروه (جدا از نوار، در گوشه سمت راست) ===== */}
      <NavLink
        to="/team-dashboard"
        className={({ isActive }) => `group-btn ${isActive ? 'active' : ''} ${isScrolled ? 'scrolled' : ''}`}
      >
        {({ isActive }) => (
          <>
            {isActive && <span className="glow-ring"></span>}
            <i className="fas fa-users"></i>
            <span className="label">گروه</span>
          </>
        )}
      </NavLink>
    </div>
  );
};

export default BottomNav;